const prefix = 'features/voting-rounds';

export const SET_VOTING_ROUND_STATUSES = `${prefix}/SET_STATUS_MULTIPLE`;

export const SET_VOTING_ROUND_STATUS = `${prefix}/SET_STATUS_SINGLE`;



// WEBPACK FOOTER //
// ./src/store/features/voting-rounds/action-types.js